import moment from 'moment'
import React from 'react'
import constant from '../../../../constant'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import Paginations from '../../../common/paginations'
import ReportActions from '../../Report/reportActions'
import DeleteFormAction from '../../../common/DeleteFormAction'
const FORM_CODE = 'SM-018';
const FORM_NAME = 'Final Delivery Document Check Sheet';

const List = ({ data, setPage, filterPayload, onDeleted }) => {
    const { submissions, page, limit, total } = data;


    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table align-middle table-nowrap table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col" style={{ width: 70 }}>
                                            ID
                                        </th>
                                        <th scope="col" style={{ width: 70 }}>
                                            CHECKLIST
                                        </th>
                                        <th scope="col">VESSEL</th>
                                        <th scope="col">DATE SUBMITTED </th>
                                        <th scope="col">STATUS </th>
                                        <th scope="col">SITE MANAGER </th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {submissions?.length > 0 ? submissions?.map((item, index) => {
                                        const serialNumber = (page - 1) * limit + index + 1;

                                        return (
                                            <tr>
                                                <td>{serialNumber}</td>
                                                <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                                    Final Delivery Document Checksheet
                                                </td>
                                                <td>
                                                    <p className="text-muted mb-0">
                                                        <span style={{ color: "#ab5858 !important" }}>
                                                            {item.HULL_NUMBER} - {item.SHIP_NAME} - {item.PROJECT_NAME}
                                                        </span>
                                                    </p>

                                                </td>
                                                <td>
                                                    {item.SUBMISSION_DATE ? moment(item.SUBMISSION_DATE).format('DD-MM-YYYY') : 'NA'}
                                                </td>
                                                <td>
                                                    {!item.FINAL_SUBMITTED ? 'DRAFT' : 'SUBMITTED'}
                                                </td>
                                                <td>
                                                    {item.SITE_MANAGER_NAME || 'NA'}
                                                </td>
                                                <td>
                                                    <ul className="list-inline font-size-20 contact-links mb-0">
                                                        <li className="list-inline-item px-0">
                                                            <Link to={{
                                                                pathname: constant.Authedcomponent.submitNewBuildingFinalDeliveryDocumentChecksheet.url,
                                                                state: {
                                                                    data: btoa(JSON.stringify(item)),
                                                                    page: page,
                                                                },
                                                            }
                                                            }

                                                                title="Edit Form">
                                                                <i className="bx bx-edit" />
                                                            </Link>
                                                        </li>
                                                        <ReportActions
                                                            item={item}
                                                            formCode={FORM_CODE}
                                                            formName={FORM_NAME}
                                                        />
                                                        <DeleteFormAction
                                                            item={item}
                                                            formCode={FORM_CODE}
                                                            formName={FORM_NAME}
                                                            onDeleted={onDeleted}
                                                        />
                                                        {/* <li className="list-inline-item px-0">
                                                            <a
                                                                href="javascript:void(0)"
                                                                style={{ color: "red" }}
                                                                title="Archive Form"
                                                            >
                                                                <i className="bx bx-trash" />
                                                            </a>
                                                        </li> */}
                                                    </ul>
                                                </td>
                                            </tr>
                                        )
                                    })
                                        : <tr>
                                            <td colSpan="7" className="text-center text-muted py-3">
                                                No records found.
                                            </td>
                                        </tr>
                                    }

                                </tbody>
                            </table>
                        </div>
                        <Paginations
                            limit={limit}
                            totalCount={total}
                            range={5}
                            currentPage={page}
                            onPageChange={setPage}
                        />

                    </div>
                </div>
            </div>
        </div >

    )
}

export default List